import {sprintf} from 'sprintf-js';
import createFragment from 'react-addons-create-fragment';

export function safe_sprintf(locale, string, vars) {
  try {
    if (vars && Array.isArray(vars)) {
      return sprintf(string, ...vars);
    }
    return sprintf(string, vars);
  } catch (error) {
    console.error(`Error in locale "${locale}" in string "${string}"`, vars);
    console.error(error);
    return '';
  }
}

function arrayToFragment(array) {
  if (!array) return undefined;
  return createFragment(array.reduce((object, value, index) => {
    object['part' + index] = value;
    return object;
  }, {}));
}

function resolvePlural(strings, vars, nkey) {
  let val;
  if (nkey == null) {
    val = vars;
  } else {
    val = vars[nkey];
  }
  if (+val === 1) {
    return strings[1];
  }
  return strings[2];
}

/* implementation of __ */
export function translate(dictionary, locale, string, vars) {
  if (dictionary) {
    string = dictionary[string] && dictionary[string][1];
  }
  return safe_sprintf(locale, string, vars);
}

/* implementation of _n */
export function translatePlural(dictionary, locale, string, string_plural, vars, nkey) {
  let strings;
  if (dictionary) {
    strings = dictionary[string];
  }
  if (!strings) {
    strings = [null, string, string_plural];
  }
  return safe_sprintf(locale, resolvePlural(strings, vars, nkey), vars);
}

/* implementation of _x */
export function translateContext(dictionary, locale, string, context, vars) {
  if (dictionary) {
    string = dictionary[`${context}\u0004${string}`] && dictionary[`${context}\u0004${string}`][1];
  }
  return safe_sprintf(locale, string, vars);
}

/* implementation of _nx */
export function translatePluralContext(dictionary, locale, string, string_plural, context, vars, nkey) {
  let strings;
  if (dictionary) {
    strings = dictionary[`${context}\u0004${string}`];
  } else {
    strings = [null, string, string_plural];
  }
  return safe_sprintf(locale, resolvePlural(strings, vars, nkey), vars);
}

/* implementation of __raw */
export function translateRaw(dictionary, locale, string) {
  if (dictionary) {
    string = dictionary[string] && dictionary[string][1];
  }
  return string;
}

export function sprintf_react(locale, string, vars) {
  if (!vars) return safe_sprintf(locale, string, vars);

  const keys = Object.keys(vars);

  const replacementKeys = keys.map(key => `$$$${key}$$$`);
  const replacements = keys.reduce((obj, key, index) => {
    obj[key] = replacementKeys[index];
    return obj;
  }, {});

  const result = safe_sprintf(locale, string, replacements);

  if (!keys.length) return result;

  const indexes = replacementKeys.map(replacement => result.indexOf(replacement));

  const parts = [];

  let index;
  let lastIndex = 0;
  while (true) {
    index = Math.min(...indexes.filter(x => x >= 0));
    let found = indexes.indexOf(index);

    if (found !== -1) {
      // next index
      indexes[found] = result.indexOf(replacementKeys[found], index + 1);
    }

    // add everything before index
    if (index === lastIndex || lastIndex === result.length) {
      // empty string
    } else {
      let end = index - lastIndex;
      if (!isFinite(index)) {
        end = result.length - lastIndex;
      }
      parts.push(result.substr(
        lastIndex,
        end,
      ));
    }

    if (!isFinite(index)) {
      // done all replacements
      if (parts.length < 1) return parts[0];
      return parts;
    }

    parts.push(vars[keys[found]]);

    lastIndex = index + replacementKeys[found].length;
  }
}

/* implementation of __react */
/** vars can contain react elements and output should be a jsx array */
export function translateReact(dictionary, locale, string, vars) {
  if (dictionary) {
    string = dictionary[string] && dictionary[string][1];
  }

  return arrayToFragment(sprintf_react(locale, string, vars));
}

/* implementation of _nreact */
export function translatePluralReact(dictionary, locale, string, string_plural, vars, nkey) {
  let strings;
  if (dictionary) {
    strings = dictionary[string];
  } else {
    strings = [null, string, string_plural];
  }
  return arrayToFragment(sprintf_react(locale, resolvePlural(strings, vars, nkey), vars));
}



// WEBPACK FOOTER //
// ./spa/state/i18n/functions.jsx